export default "__VITE_ASSET__hZptoFA6__"